import styled from 'styled-components';

export const PageLayout = styled.main`
  min-height: 50vh;
  padding-bottom: 2.5rem;
`;
